<template>
  <section>
    <Navbar />
    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="searchingGroup"
    >
      <GroupPreview :groupInfo="groupPreview" />
    </div>
    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="creatingGroup"
    >
      <CreateGroup />
    </div>
    <div class="createGroupButton" @click="createGroup">
      <img src="@/assets/createGroupIcon.svg" class="createGroupImg" />
    </div>
    <div class="mainDiscover">
      <!-- FIRST COLUMN -->
      <!--div class="flexLeft">
        <Groups />
      </div-->
      <div class="titleRow">
        <span
          class="showBar"
          :class="{
            discoverShift: discoverWorld,
            campusShift: exploreCampus,
          }"
        ></span>
        <div class="findCourseTitle" @click="goToWorld()">Discover World</div>
        <div class="findCourseTitle" @click="goToCampus()">Explore Campus</div>
      </div>
      <div id="scrollBody">
        <input
          id="searchDiscoverBar"
          list="searchContent"
          v-model="searchString"
          type="text"
          @focus="focused = true"
          @blur="focused = false"
          @keydown="checkTime($event)"
          :placeholder="placeholderText"
          autocomplete="off"
        />
        <div v-if="focused" class="discoverSearchBox">
          <div v-if="loading" class="loaderContainer">
            <div class="loader"></div>
          </div>
          <div v-else>
            <template v-if="checkEmpty()">
              <div v-if="searchString.length === 0" class="emptyContainer">
                <img src="@/assets/Icons/StartSearchIcon.svg" />
                <b>Search for friends, courses, and groups!</b>
              </div>
              <div v-else class="emptyContainer">
                <img src="@/assets/Icons/EmptyIcon.svg" />
                <b>Oh no! We can't find what you're looking for</b>
              </div>
            </template>
            <ul
              class="searchContent"
              v-for="(object, index) in totalSearch"
              :key="index"
            >
              <template v-if="object.type == 'global'">
                <li
                  v-on:mousedown="
                    searchCourse(object.doc, object.id, object.type)
                  "
                  class="profileOption"
                >
                  <img
                    :src="object.doc.profileImage"
                    class="searchProfileImage"
                  />
                  {{ object.doc.name }}<br />
                  Global Chat
                </li>
              </template>
              <template v-else>
                <li
                  v-on:mousedown="
                    searchCourse(object.doc, object.id, object.type)
                  "
                  class="profileOption"
                >
                  <img
                    :src="object.doc.profileImage"
                    class="searchProfileImage"
                  />
                  {{ object.doc.name }}<br />
                  Campus Chat
                </li>
              </template>
            </ul>
          </div>
        </div>
        <template v-if="discoverWorld && featuredGroups.length > 0">
          <div class="discoverTitleAndIcon">
            <span id="toGeneral" class="translateJump"></span>
            <div class="bodyTitle">Featured Chats</div>
          </div>
          <div class="loaderContainer" v-if="!this.groupsLoaded">
            <div class="loader"></div>
          </div>
          <div class="sideScrollContainer" v-else>
            <span
              v-if="notFeaturedLeft"
              @click="verticalScroll('.FeaturedScroll', -1027)"
              class="scrollArrow leftArrow"
            >
              <img src="@/assets/rightArrow.svg" />
            </span>
            <span
              v-if="notFeaturedRight"
              @click="verticalScroll('.FeaturedScroll', 1027)"
              class="scrollArrow rightArrow"
            >
              <img src="@/assets/rightArrow.svg" />
            </span>
            <div
              class="sideBox FeaturedScroll"
              id="generalScroll"
              @scroll="handleFeaturedScroll"
            >
              <div
                class="eachGroup"
                v-for="(group, index) in featuredGroups"
                :key="index"
                :class="{
                  firstGroup: index == 0,
                }"
              >
                <div class="topGroupRow">
                  <div class="groupImage">
                    <img class="cover" :src="group.groupImage" />
                  </div>
                  <div class="textInfo">
                    <p class="groupTitle">{{ group.groupTitle }}</p>
                    <p class="memberNum" v-if="group.groupUserCount >= 25">
                      {{ group.groupUserCount }} members
                    </p>
                    <p class="memberNum" v-else>New Group</p>
                  </div>
                </div>
                <div class="bottomGroupRow">
                  <div
                    @click="
                      searchCourse(
                        group.groupDoc,
                        group.groupID,
                        group.groupType
                      )
                    "
                    class="viewGroupButton"
                  >
                    <p>View Group</p>
                  </div>
                  <!--p class="description">{{ group.groupDescription }}</p-->
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="discoverTitleAndIcon">
          <span id="toGeneral" class="translateJump"></span>
          <div class="bodyTitle">Campus Groups</div>
        </div>
        <div class="loaderContainer" v-if="!this.groupsLoaded">
          <div class="loader"></div>
        </div>
        <div class="sideScrollContainer" v-else>
          <span
            v-if="notCampusLeft"
            @click="verticalScroll('.CampusScroll', -1027)"
            class="scrollArrow leftArrow"
          >
            <img src="@/assets/rightArrow.svg" />
          </span>
          <span
            v-if="notCampusRight"
            @click="verticalScroll('.CampusScroll', 1027)"
            class="scrollArrow rightArrow"
          >
            <img src="@/assets/rightArrow.svg" />
          </span>
          <div
            class="sideBox CampusScroll"
            id="generalScroll"
            @scroll="handleCampusScroll"
          >
            <div
              class="eachGroup"
              v-for="(group, index) in generalGroups"
              :key="index"
              :class="{
                firstGroup: index == 0,
              }"
            >
              <div class="topGroupRow">
                <div class="groupImage">
                  <img class="cover" :src="group.groupImage" />
                </div>
                <div class="textInfo">
                  <p class="groupTitle">{{ group.groupTitle }}</p>
                  <p class="memberNum" v-if="group.groupUserCount >= 25">
                    {{ group.groupUserCount }} members
                  </p>
                  <p class="memberNum" v-else>New Group</p>
                </div>
              </div>
              <div class="bottomGroupRow">
                <div
                  @click="
                    searchCourse(group.groupDoc, group.groupID, group.groupType)
                  "
                  class="viewGroupButton"
                >
                  <p>View Group</p>
                </div>
                <!--p class="description">{{ group.groupDescription }}</p-->
              </div>
            </div>
          </div>
          <div class="arrowContainer" id="generalArrow">
            <img height="50" width="50" src="@/assets/rightArrow.svg" />
          </div>
        </div>
        <div v-if="recommendedGroups.length > 0" class="discoverTitleAndIcon">
          <span id="toRecommended" class="translateJump"></span>
          <div class="bodyTitle">Suggested for you</div>
        </div>
        <div v-if="recommendedGroups.length > 0" class="listBox">
          <div
            class="interestGroup"
            v-for="(recommend, index) in recommendedGroups"
            :key="index"
          >
            <template v-if="index < 4">
              <div class="topGroupRow">
                <div class="groupImage">
                  <img class="cover" :src="recommend.groupImage" />
                </div>
                <div class="textInfo">
                  <p class="groupTitle">{{ recommend.groupTitle }}</p>
                  <p class="memberNum" v-if="recommend.groupUserCount >= 25">
                    {{ recommend.groupUserCount }} members
                  </p>
                  <p class="memberNum" v-else>New Group</p>
                </div>
                <div class="interestRow">
                  <img
                    src="@/assets/mutualInterests.svg"
                    height="30"
                    width="30"
                    v-if="recommend.isInterestBased"
                  />
                  <img
                    src="@/assets/mutualFriends.svg"
                    v-else
                    height="30"
                    width="30"
                  />
                  <p style="margin-left: 2px">
                    {{ recommend.recommendedString }}
                  </p>
                </div>
              </div>
              <div class="bottomGroupRow">
                <div
                  @click="
                    searchCourse(
                      recommend.groupDoc,
                      recommend.groupID,
                      recommend.groupType
                    )
                  "
                  class="viewGroupButton"
                >
                  <p>View Group</p>
                </div>
                <!--p class="description">{{ group.groupDescription }}</p-->
              </div>
            </template>
          </div>
          <div style="width: 100%">
            <div
              class="viewMoreButton"
              v-if="recommendedGroups.length > 5"
              @click="goToMoreGroups('Suggested for you')"
            >
              View More
            </div>
          </div>
        </div>
        <div class="discoverTitleAndIcon">
          <span id="toRecommended" class="translateJump"></span>
          <div class="bodyTitle">Categories</div>
        </div>
        <span
          v-if="notCatLeft"
          @click="verticalScroll('.CatScroll', -1027)"
          class="scrollArrow leftArrow catArrow"
        >
          <img src="@/assets/rightArrow.svg" />
        </span>
        <span
          v-if="notCatRight"
          @click="verticalScroll('.CatScroll', 1027)"
          class="scrollArrow rightArrow catArrow"
        >
          <img src="@/assets/rightArrow.svg" />
        </span>
        <div class="sideBox CatScroll" @scroll="handleCatScroll">
          <div
            class="categoryContainer"
            v-for="(category, index) in categories"
            :key="index"
            @click="selectCategory(category.title)"
            :class="{
              firstGroup: index == 0,
            }"
          >
            <div
              class="category"
              :style="{
                backgroundImage: 'url(' + category.url + ')',
              }"
            ></div>
            <p class="categoryTitle">{{ category.title }}</p>
          </div>
        </div>

        <template v-if="selectedCategory != ''">
          <div class="categoryColumn">
            <div class="categoryBox">
              <div
                class="loaderContainer"
                v-if="categoryGroups.length == 0 && !doneSearching"
              >
                <div class="loader"></div>
              </div>
              <div
                v-else
                class="categoryGroup"
                v-for="(categoryGroup, categoryIndex) in categoryGroups"
                :key="categoryIndex"
              >
                <template v-if="categoryIndex < 5">
                  <div class="topGroupRow">
                    <img
                      class="categoryImage"
                      :src="categoryGroup.groupImage"
                    />
                    <div class="textInfo">
                      <p class="groupTitle">{{ categoryGroup.groupTitle }}</p>
                      <p
                        class="memberNum"
                        v-if="categoryGroup.groupUserCount >= 25"
                      >
                        {{ categoryGroup.groupUserCount }} members
                      </p>
                      <p class="memberNum" v-else>New Group</p>
                    </div>
                  </div>
                </template>
              </div>
              <br />
            </div>
            <div
              class="viewMoreButton"
              v-if="categoryGroups.length > 5"
              @click="goToMoreGroups('')"
            >
              View More
            </div>
          </div>
        </template>
        <div class="discoverTitleAndIcon">
          <span id="toRecommended" class="translateJump"></span>
          <div class="bodyTitle">Meet {{ schoolName }} students</div>
        </div>
        <div class="loaderContainer" v-if="!this.doneLoading">
          <div class="loader"></div>
        </div>
        <div v-else>
          <span
            v-if="notUserLeft"
            @click="verticalScroll('.UserScroll', -1040)"
            class="scrollArrow leftArrow userArrow"
          >
            <img src="@/assets/rightArrow.svg" />
          </span>
          <span
            v-if="notUserRight"
            @click="verticalScroll('.UserScroll', 1040)"
            class="scrollArrow rightArrow userArrow"
          >
            <img src="@/assets/rightArrow.svg" />
          </span>
          <div class="sideBox UserScroll" @scroll="loadMoreUsers($event)">
            <div
              class="eachUser"
              v-for="(userDoc, userIndex) in suggestedUsers"
              :key="userIndex"
              @click="searchUser(userDoc.firstName, userDoc.lastName)"
              :class="{
                firstGroup: userIndex == 0,
              }"
            >
              <div class="groupImage">
                <img class="userImage" :src="userDoc.profileImage" />
              </div>
              <div class="bottomRow">
                <p class="groupTitle">
                  {{ userDoc.firstName }} {{ userDoc.lastName }}
                </p>
                <p>
                  {{ userDoc.year }} {{ userDoc.hasDash }}
                  {{ userDoc.releventInfo }}
                </p>
              </div>
            </div>
            <div v-if="loadingUsers && !reachedEnd" class="loadingUser">
              <div class="loader"></div>
            </div>
          </div>
        </div>
        <div class="discoverTitleAndIcon">
          <span id="toExplore" class="translateJump"></span>
          <div class="bodyTitle">More Groups</div>
        </div>
        <div class="listBox">
          <div
            class="eachGroup"
            style="margin: 5px"
            v-for="(explore, index) in exploreGroups"
            :key="index"
          >
            <div class="topGroupRow">
              <div class="groupImage">
                <img class="cover" :src="explore.groupImage" />
              </div>

              <div class="textInfo">
                <p class="groupTitle">{{ explore.groupTitle }}</p>
                <p class="memberNum" v-if="explore.groupUserCount >= 25">
                  {{ explore.groupUserCount }} members
                </p>
                <p class="memberNum" v-else>New Group</p>
              </div>
            </div>
            <div class="bottomGroupRow">
              <div
                class="viewGroupButton"
                @click="
                  searchCourse(
                    explore.groupDoc,
                    explore.groupID,
                    explore.groupType
                  )
                "
              >
                <p>View Group</p>
              </div>
              <!--p class="description">{{ group.groupDescription }}</p-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
//import Groups from "@/components/Groups";
import db from "@/db";
//import firebase from "@/firebase";
import Navbar from "@/components/Navbar";
import GroupPreview from "@/components/group/GroupPreview.vue";
import CreateGroup from "@/components/group/CreateGroup.vue";

export default {
  components: {
    //Groups,
    Navbar,
    GroupPreview,
    CreateGroup,
  },
  data: () => ({
    doneLoading: false,
    groupsLoaded: false,
    autoScrolling: false,
    lastTimeScroll: 0,
    selectedCategory: "",
    categoryGroups: [],
    discoverWorld: true,
    exploreCampus: false,
    allGroups: [],
    featuredGroups: [],
    generalGroups: [],
    recommendedGroups: [],
    exploreGroups: [],
    tempGroups: [],
    fetchedUserIds: [],
    shownUserIds: [],
    suggestedUsers: [],
    storedUserDocs: [],
    randomUserCount: [],
    schoolName: "",
    lastInterestCount: 0,
    userInterests: [],
    currentUser: null,
    loadingUsers: false,
    placeholderText: "Search all of Canada",
    searchString: "",
    doneTyping: false,
    loading: false,
    totalSearch: [],
    focused: false,
    doneSearching: false,
    notFeaturedLeft: false,
    notFeaturedRight: true,
    notCampusLeft: false,
    notCampusRight: true,
    notCatLeft: false,
    notCatRight: true,
    notUserLeft: false,
    notUserRight: true,
    reachedEnd: false,
    categories: [
      {
        title: "Sports",
        url:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/catgoryImages%2Fsports.jpg?alt=media&token=11dfbe1a-ea57-4bfc-a13f-3595d94a1a83",
      },
      {
        title: "Social",
        url:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/catgoryImages%2FSocial.jpg?alt=media&token=1992ad06-62a9-44c8-b22f-66b5ea73dc1e",
      },
      {
        title: "Outdoors",
        url:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/catgoryImages%2Foutdoors.jpg?alt=media&token=4ad892df-4336-423a-a1ee-f8a132259e01",
      },
      {
        title: "Creative",
        url:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/catgoryImages%2Fcreative.jpg?alt=media&token=cce3ee87-23b8-417d-b01e-861964b3f6f7",
      },
      {
        title: "Food & Drink",
        url:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/catgoryImages%2FFood%26Drink.jpg?alt=media&token=04d69abd-dedc-4699-a770-c572d93a9c53",
      },
      {
        title: "Entertainment",
        url:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/catgoryImages%2Fentertainment.jpg?alt=media&token=b7744102-67bf-451e-b840-4e5b4b627b3f",
      },
      {
        title: "Wellness",
        url:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/catgoryImages%2Fwellness.jpg?alt=media&token=74c77ea1-6b34-461c-9318-b29b50396d8c",
      },
      {
        title: "Tech",
        url:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/catgoryImages%2Ftech.jpg?alt=media&token=02dac260-fb72-4adf-aec8-3939441bba91",
      },
      {
        title: "World Affairs",
        url:
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/catgoryImages%2FworldAffairs.jpg?alt=media&token=e877ea0e-e6ae-4388-9cb4-1a2742fc53cc",
      },
    ],
  }),
  created() {
    this.fetchUserInterests();
    this.fetchAllgroups();
    this.fetchUsers();
  },
  mounted() {},
  computed: {
    ...mapState("messageBoard", [
      "groupId",
      "groupName",
      "searchingGroup",
      "groupPreview",
      "creatingGroup",
    ]),
    ...mapState("user", ["user"]),
  },
  watch: {
    doneTyping() {
      if (this.doneTyping) {
        if (this.searchString.length != 0) {
          this.loading = true;
          var lowerString = this.searchString.toLowerCase();
          this.searchArray = lowerString.split(/(?:-| )+/);
          this.searchDatabase();
        } else {
          this.totalSearch;
        }
      }
    },
  },
  methods: {
    ...mapActions("messageBoard", ["setSearchGroup", "setGroupPreview"]),
    searchUser(firstName, lastName) {
      this.$router.replace({
        name: "PublicProfile",
        params: { userName: firstName + "-" + lastName },
      });
    },
    checkTime(event) {
      var keycode = event.keyCode;
      if (
        (keycode > 47 && keycode < 58) || // number keys
        keycode == 32 ||
        keycode == 8 ||
        keycode == 13 || // spacebar/backspace & return key(s) (if you want to allow carriage returns)
        (keycode > 64 && keycode < 91) || // letter keys
        (keycode > 95 && keycode < 112) || // numpad keys
        (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
        (keycode > 218 && keycode < 223) // [\]' (in order)
      ) {
        this.doneTyping = false;
        setTimeout(() => {
          this.doneTyping = true;
        }, 800);
      } else {
        this.doneTyping = false;
      }
    },
    checkEmpty() {
      return !this.totalSearch.length;
    },
    handleFeaturedScroll: function(el) {
      if (el.srcElement.scrollLeft == 0) {
        this.notFeaturedLeft = false;
      } else {
        this.notFeaturedLeft = true;
      }
      if (
        el.srcElement.offsetWidth + el.srcElement.scrollLeft >=
        el.srcElement.scrollWidth
      ) {
        this.notFeaturedRight = false;
      } else {
        this.notFeaturedRight = true;
      }
    },
    handleCampusScroll: function(el) {
      if (el.srcElement.scrollLeft == 0) {
        this.notCampusLeft = false;
      } else {
        this.notCampusLeft = true;
      }
      if (
        el.srcElement.offsetWidth + el.srcElement.scrollLeft >=
        el.srcElement.scrollWidth
      ) {
        this.notCampusRight = false;
      } else {
        this.notCampusRight = true;
      }
    },
    handleCatScroll: function(el) {
      if (el.srcElement.scrollLeft == 0) {
        this.notCatLeft = false;
      } else {
        this.notCatLeft = true;
      }
      if (
        el.srcElement.offsetWidth + el.srcElement.scrollLeft >=
        el.srcElement.scrollWidth
      ) {
        this.notCatRight = false;
      } else {
        this.notCatRight = true;
      }
    },
    handleUserScroll: function(el) {
      console.log("hey");
      if (el.srcElement.scrollLeft == 0) {
        this.notUserLeft = false;
      } else {
        this.notUserLeft = true;
      }
      if (
        el.srcElement.offsetWidth + el.srcElement.scrollLeft >=
        el.srcElement.scrollWidth
      ) {
        this.notUserRight = false;
      } else {
        this.notUserRight = true;
      }
    },
    verticalScroll(box, num) {
      let content = document.querySelector(box);
      content.scrollLeft += num;
    },
    async searchDatabase() {
      var totalSearch = [];

      // Search Groups
      await db
        .collection("groups")
        .where("school_id", "==", this.user.school_id)
        .where("keywords", "array-contains-any", this.searchArray)
        .where("privacyType", "!=", "secret")
        .limit(10)
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            let data = {
              doc: doc.data(),
              searchResult: doc.data().name,
              type: "campus",
              id: doc.id,
            };
            totalSearch.push(data);
          });
        });
      if (this.discoverWorld) {
        await db
          .collection("groups")
          .where("isGlobal", "==", true)
          .where("keywords", "array-contains-any", this.searchArray)
          .where("privacyType", "!=", "secret")
          .limit(10)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              let data = {
                doc: doc.data(),
                searchResult: doc.data().name,
                type: "global",
                id: doc.id,
              };
              totalSearch.push(data);
            });
          });
      }

      // Sort search based on relevency
      var sortedSearch = [];
      for (var option = 0; option < totalSearch.length; option++) {
        let relevency = this.commonChars(
          totalSearch[option].searchResult,
          this.searchString
        );
        totalSearch[option].relevency = relevency / this.searchString.length;
        //if (relevency / this.searchString.length > 0.4) {
        sortedSearch.push(totalSearch[option]);
        //}
      }
      sortedSearch.sort((a, b) => b.relevency - a.relevency);
      this.loading = false;
      this.doneTyping = false;
      this.totalSearch = sortedSearch.slice(0, 8);
    },

    commonChars(s1, s2) {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();
      s1 = s1.split(" ");
      s2 = s2.split(" ");
      let seenChars = [];
      let shortStr;
      let longStr;
      let counter = 0;

      if (s1.length < s2.length) {
        shortStr = s1;
        longStr = s2;
      } else {
        shortStr = s2;
        longStr = s1;
      }

      for (let i = 0; i < shortStr.length; i++) {
        var shortWord;
        var longWord;
        if (shortStr[i].length < longStr[i].length) {
          shortWord = shortStr[i];
          longWord = longStr[i];
        } else {
          shortWord = longStr[i];
          longWord = shortStr[i];
        }
        for (let j = 0; j < shortWord.length; j++) {
          if (
            longWord.indexOf(shortWord[j]) !== -1 &&
            !seenChars.includes(shortWord[j])
          ) {
            counter++;
            seenChars.push(shortWord[j]);
          }
        }
      }
      return counter;
    },

    goToMoreGroups(title) {
      if (title === "") {
        this.$router.push({
          name: "MoreGroups",
          params: { category: this.selectedCategory },
        });
      } else {
        this.$router.push({
          name: "MoreGroups",
          params: { category: title },
        });
      }
    },
    async selectCategory(category) {
      this.doneSearching = false;
      this.categoryGroups = [];
      this.selectedCategory = this.selectedCategory != category ? category : "";
      var allGroups = [];
      console.log(this.selectedCategory);
      await db
        .collection("categories")
        .where("name", "==", this.selectedCategory)
        .get()
        .then(async (categories) => {
          categories.forEach(async (category) => {
            var interests = category.data().interests;
            var totalInterests = interests;
            while (interests.length) {
              totalInterests = interests.splice(0, 10);
              await db
                .collection("groups")
                .where("interests", "array-contains-any", totalInterests)
                .where("privacyType", "!=", "secret")
                .where("school_id", "==", this.user.school_id)
                .limit(10)
                .get()
                .then((docs) => {
                  docs.forEach((doc) => {
                    if (
                      allGroups.findIndex((x) => x.groupID === doc.id) === -1
                    ) {
                      allGroups.push({
                        groupTitle: doc.data().name,
                        groupImage: doc.data().profileImage,
                        groupDescription: doc.data().description,
                        groupUserCount: doc.data().userCount
                          ? doc.data().userCount
                          : 0,
                        groupDoc: doc.data(),
                        groupType: "groups",
                        groupID: doc.id,
                      });
                    }
                  });
                });
              if (this.discoverWorld) {
                await db
                  .collection("groups")
                  .where("interests", "array-contains-any", totalInterests)
                  .where("isGlobal", "==", true)
                  .limit(10)
                  .get()
                  .then((docs) => {
                    docs.forEach((doc) => {
                      if (
                        allGroups.findIndex((x) => x.groupID === doc.id) === -1
                      ) {
                        allGroups.push({
                          groupTitle: doc.data().name,
                          groupImage: doc.data().profileImage,
                          groupDescription: doc.data().description,
                          groupUserCount: doc.data().userCount
                            ? doc.data().userCount
                            : 0,
                          groupDoc: doc.data(),
                          groupType: "groups",
                          groupID: doc.id,
                        });
                      }
                    });
                  });
              }
            }
            this.categoryGroups = allGroups;
            this.doneSearching = true;
          });
        });
    },
    checkGeneral({ target: { scrollLeft } }) {
      document.getElementById("generalArrow").style.display =
        scrollLeft >= 0 ? "block" : "none";
      /*
      if (!this.autoScrolling) {
        setTimeout(() => {
          if (scrollLeft > 0 && scrollLeft < 160) {
            document.getElementById("generalScroll").scrollTo(0, 0);
            this.autoScrolling = true;
          } else if (scrollLeft > 160 && scrollLeft < 320) {
            document.getElementById("generalScroll").scrollTo(310, 0);
            this.autoScrolling = true;
          } else if (scrollLeft > 320 && scrollLeft < 480) {
            document.getElementById("generalScroll").scrollTo(310, 0);
            this.autoScrolling = true;
          } else if (scrollLeft > 480) {
            document.getElementById("generalScroll").scrollTo(620, 0);
            this.autoScrolling = true;
          }
        }, 250);
      }
      if (scrollLeft === 0 || scrollLeft === 160) {
        this.autoScrolling = false;
      }*/
    },
    createGroup() {
      this.$store.commit("messageBoard/setCreateGroup", true);
    },
    cancelPreview(event) {
      if (event.target.className == "previewContainer") {
        this.$store.commit("messageBoard/setSearchGroup", false);
        this.$store.commit("messageBoard/setCreateGroup", false);
        this.$store.commit("profile/setInterests", []);
      }
    },
    searchCourse(course, id, type) {
      course.id = id;
      course.type = type;
      this.$store.commit("messageBoard/setSearchGroup", true);
      this.$store.commit("messageBoard/setGroupPreview", course);
    },
    async fetchUserInterests() {
      await db
        .collection("users")
        .doc(this.user.id)
        .get()
        .then((doc) => {
          for (const index in doc.data().interests) {
            this.userInterests.push(doc.data().interests[index].unicode);
          }
        });
    },
    addGroups(group, id) {
      if (
        group.privacyType != "secret" &&
        this.user.allGroups.findIndex((x) => x.id === id) === -1
      ) {
        // group is never undefined for query doc snapshots
        if (group.isGeneral) {
          this.generalGroups.push({
            groupTitle: group.name,
            groupImage: group.profileImage,
            groupDescription: group.description,
            groupUserCount: group.userCount ? group.userCount : 0,
            groupDoc: group,
            groupType: "groups",
            groupID: id,
          });
        } else {
          let interests = group.interests;
          var recommendedString = "";
          var sameInterests = 0;
          for (const index in interests) {
            for (const index2 in this.userInterests) {
              if (interests[index].unicode == this.userInterests[index2]) {
                sameInterests++;
                recommendedString = "Because you like " + interests[index].name;
              }
            }
          }
          var mutualMembers = [];
          if (group.users) {
            group.users.forEach((user) => {
              if (this.user.links.includes(user.user_id)) {
                mutualMembers.push(user.name.split(" ")[0]);
              }
            });
          }

          if (sameInterests != 0) {
            this.recommendedGroups.push({
              groupTitle: group.name,
              groupImage: group.profileImage,
              groupDescription: group.description,
              groupUserCount: group.userCount ? group.userCount : 0,
              groupDoc: group,
              groupType: "groups",
              groupID: id,
              interests: group.interests,
              recommendedString: recommendedString,
              isInterestBased: true,
            });
          } else if (mutualMembers.length != 0) {
            if (recommendedString === "") {
              if (mutualMembers.length === 1) {
                recommendedString = mutualMembers[0] + " is a member";
              } else if (mutualMembers.length === 2) {
                recommendedString =
                  mutualMembers[0] +
                  " and " +
                  mutualMembers[1] +
                  " are members";
              } else {
                recommendedString =
                  mutualMembers[0] +
                  " and " +
                  (mutualMembers.length - 1) +
                  " friends are members";
              }
            }
            this.recommendedGroups.push({
              groupTitle: group.name,
              groupImage: group.profileImage,
              groupDescription: group.description,
              groupUserCount: group.userCount ? group.userCount : 0,
              groupDoc: group,
              groupType: "groups",
              groupID: id,
              recommendedString: recommendedString,
            });
          } else {
            this.exploreGroups.push({
              groupTitle: group.name,
              groupImage: group.profileImage,
              groupDescription: group.description,
              groupUserCount: group.userCount ? group.userCount : 0,
              groupDoc: group,
              groupType: "groups",
              groupID: id,
            });
          }

          this.allGroups.push({
            groupTitle: group.name,
            groupImage: group.profileImage,
            groupDescription: group.description,
            groupUserCount: group.userCount ? group.userCount : 0,
            //groupInterests: group.interests,
          });
        }
      }
    },
    async fetchAllgroups() {
      this.groupsLoaded = false;
      if (this.discoverWorld) {
        await db
          .collection("groups")
          .where("isFeatured", "==", true)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach(async (doc) => {
              this.featuredGroups.push({
                groupTitle: doc.data().name,
                groupImage: doc.data().profileImage,
                groupDescription: doc.data().description,
                groupUserCount: doc.data().userCount ? doc.data().userCount : 0,
                groupDoc: doc.data(),
                groupType: "groups",
                groupID: doc.id,
              });
            });
          });
      }
      await db
        .collection("groups")
        .where("school_id", "==", this.user.school_id)
        .where("isGeneral", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            this.addGroups(doc.data(), doc.id);
          });
        });
      await db
        .collection("groups")
        .where("school_id", "==", this.user.school_id)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            if (!doc.data().isGeneral) {
              this.addGroups(doc.data(), doc.id);
            }
          });
        });
      if (this.discoverWorld) {
        await db
          .collection("groups")
          .where("isGlobal", "==", true)
          .limit(5)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach(async (doc) => {
              this.addGroups(doc.data(), doc.id);
            });
          });
      }
      this.groupsLoaded = true;
    },
    shuffle(array) {
      array.sort(() => Math.random() - 0.5);
    },
    async loadMoreUsers(event) {
      this.loadingUsers = true;
      if (event.srcElement.scrollLeft == 0) {
        this.notUserLeft = false;
      } else {
        this.notUserLeft = true;
      }
      if (
        event.srcElement.offsetWidth + event.srcElement.scrollLeft >=
        event.srcElement.scrollWidth
      ) {
        this.notUserRight = false;
      } else {
        this.notUserRight = true;
      }
      if (
        event.srcElement.offsetWidth + event.srcElement.scrollLeft >=
        event.srcElement.scrollWidth
      ) {
        var totalAdditionalUsers = [];
        if (this.storedUserDocs.length > 0) {
          totalAdditionalUsers = this.storedUserDocs;
          this.storedUserDocs = [];
        }
        if (this.fetchedUserIds.length > 0) {
          await Promise.all(
            this.fetchedUserIds.map(async (userId, index) => {
              if (index < 15) {
                await db
                  .collection("users")
                  .doc(userId)
                  .get()
                  .then((doc) => {
                    if (doc.data().school_id === this.user.school_id) {
                      this.shownUserIds.push(userId);
                      totalAdditionalUsers.push(doc.data());
                      this.storedUserDocs.push(doc.data());
                      if (this.fetchedUserIds.includes(userId)) {
                        let index = this.fetchedUserIds.indexOf(userId);
                        this.fetchedUserIds.splice(index);
                      }
                      let index = this.randomUserCount.indexOf(
                        doc.data().profileImageNumber
                      );
                      if (index > -1) {
                        this.randomUserCount.splice(index, 1);
                      }
                    }
                  });
              }
            })
          );
        }
        this.setUsers(totalAdditionalUsers);
        totalAdditionalUsers.sort((a, b) => b.priority - a.priority);
        this.storedUserDocs.sort((a, b) => b.priority - a.priority);
        this.storedUserDocs = this.storedUserDocs.slice(15);
        totalAdditionalUsers = totalAdditionalUsers.slice(0, 15);
        var limit;
        if (this.fetchedUserIds.length < 15) {
          let diff = 15 - this.fetchedUserIds.length;
          limit = Math.floor(Math.random() * (11 + diff - 6 + diff) + 6 + diff);
        } else {
          limit = Math.floor(Math.random() * (11 - 6) + 6);
        }
        var promises = [];
        for (var j = 0; j < limit; j++) {
          promises.push(j);
        }
        await Promise.all(
          promises.map(async () => {
            let rand = Math.floor(
              Math.random() * (this.randomUserCount.length - 1)
            );
            if (rand !== -1) {
              this.notUserRight = true;
              let value = this.randomUserCount[rand];
              this.randomUserCount.splice(rand, 1);
              await db
                .collection("users")
                .where("school_id", "==", this.user.school_id)
                .where("profileImageNumber", "==", value)
                .get()
                .then((userDocs) => {
                  userDocs.forEach((userDoc) => {
                    if (
                      userDoc.id !== this.user.id &&
                      !this.user.links.includes(userDoc.id) &&
                      !this.shownUserIds.includes(userDoc.id)
                    ) {
                      this.shownUserIds.push(userDoc.id);
                      totalAdditionalUsers.push(userDoc.data());
                      if (this.fetchedUserIds.includes(userDoc.id)) {
                        let index = this.fetchedUserIds.indexOf(userDoc.id);
                        this.fetchedUserIds.splice(index);
                      }
                    }
                  });
                });
            } else {
              this.reachedEnd = true;
            }
          })
        );
        this.shuffle(totalAdditionalUsers);
        this.loadingUsers = false;
        this.suggestedUsers.push(...totalAdditionalUsers);
      }
    },
    async fetchUsers() {
      this.doneLoading = false;
      await Promise.all(
        this.user.links.map(async (link, index) => {
          if (index < 10) {
            await db
              .collection("users")
              .doc(link)
              .get()
              .then((doc) => {
                if (doc.data().links) {
                  this.fetchedUserIds.push(...doc.data().links);
                }
              });
          }
        })
      );
      await Promise.all(
        this.user.courses.map(async (course) => {
          await db
            .collection("courses")
            .doc(course.id)
            .get()
            .then((doc) => {
              doc.data().users.forEach((user) => {
                if (user.user_id !== this.user.id) {
                  this.fetchedUserIds.push(user.user_id);
                }
              });
            });
        })
      );
      await Promise.all(
        this.user.groups.map(async (group) => {
          await db
            .collection("groups")
            .doc(group.id)
            .get()
            .then((doc) => {
              doc.data().users.forEach((user) => {
                if (user.user_id !== this.user.id) {
                  this.fetchedUserIds.push(user.user_id);
                }
              });
            });
        })
      );
      await Promise.all(
        this.user.faculties.map(async (faculty) => {
          await db
            .collection("faculties")
            .doc(faculty.id)
            .get()
            .then((doc) => {
              doc.data().users.forEach((user) => {
                if (user.user_id !== this.user.id) {
                  this.fetchedUserIds.push(user.user_id);
                }
              });
            });
        })
      );
      await db
        .collection("schools")
        .doc(this.user.school_id)
        .get()
        .then(async (doc) => {
          this.schoolName = doc.data().displayName;
          for (var i = 0; i < doc.data().profileImageCount; i++) {
            this.randomUserCount.push(i);
          }
        });
      var limit;
      if (this.fetchedUserIds.length < 15) {
        let diff = 15 - this.fetchedUserIds.length;
        limit = Math.floor(Math.random() * (11 + diff - 6 + diff) + 6 + diff);
      } else {
        limit = Math.floor(Math.random() * (11 - 6) + 6);
      }
      this.fetchedUserIds = this.fetchedUserIds.filter(
        (v, i, a) =>
          a.indexOf(v) === i &&
          v !== this.user.id &&
          !this.user.links.includes(v)
      );
      await Promise.all(
        this.fetchedUserIds.map(async (userId, index) => {
          if (index < 15 && userId) {
            await db
              .collection("users")
              .doc(userId)
              .get()
              .then((doc) => {
                if (doc.data().school_id === this.user.school_id) {
                  this.shownUserIds.push(userId);
                  this.suggestedUsers.push(doc.data());
                  this.storedUserDocs.push(doc.data());
                  if (this.fetchedUserIds.includes(userId)) {
                    let index = this.fetchedUserIds.indexOf(userId);
                    this.fetchedUserIds.splice(index);
                  }
                  let index = this.randomUserCount.indexOf(
                    doc.data().profileImageNumber
                  );
                  if (index > -1) {
                    this.randomUserCount.splice(index, 1);
                  }
                }
              });
          }
        })
      );
      this.setUsers(this.suggestedUsers);
      this.suggestedUsers.sort((a, b) => b.priority - a.priority);
      this.storedUserDocs.sort((a, b) => b.priority - a.priority);
      this.storedUserDocs = this.storedUserDocs.slice(15);
      this.suggestedUsers = this.suggestedUsers.slice(0, 15);
      var promises = [];
      for (var j = 0; j < limit; j++) {
        promises.push(j);
      }
      await Promise.all(
        promises.map(async () => {
          let rand = Math.floor(
            Math.random() * (this.randomUserCount.length - 1)
          );
          let value = this.randomUserCount[rand];
          this.randomUserCount.splice(rand, 1);
          await db
            .collection("users")
            .where("school_id", "==", this.user.school_id)
            .where("profileImageNumber", "==", value)
            .get()
            .then((userDocs) => {
              userDocs.forEach((userDoc) => {
                if (
                  userDoc.id !== this.user.id &&
                  !this.user.links.includes(userDoc.id)
                ) {
                  this.shownUserIds.push(userDoc.id);
                  this.suggestedUsers.push(userDoc.data());
                  if (this.fetchedUserIds.includes(userDoc.id)) {
                    let index = this.fetchedUserIds.indexOf(userDoc.id);
                    this.fetchedUserIds.splice(index);
                  }
                }
              });
            });
        })
      );
      this.shuffle(this.suggestedUsers);
      this.doneLoading = true;
    },
    setUsers(userDocArray) {
      userDocArray.forEach((user, index) => {
        let priority = 0;
        var numMutuals = 0;
        var mutualTracker = [];
        // Mutual courses
        user.courses.forEach((course) => {
          if (numMutuals < 5 && this.user.course_ids.includes(course.id)) {
            numMutuals += 1;
          }
        });
        priority += this.getPriorityFor(numMutuals);
        mutualTracker.push({
          value: numMutuals,
          text: "courses",
        });
        numMutuals = 0;
        // Mutual groups
        user.groups.forEach((group) => {
          if (numMutuals < 5 && this.user.group_ids.includes(group.id)) {
            numMutuals += 1;
          }
        });
        priority += this.getPriorityFor(numMutuals);
        mutualTracker.push({
          value: numMutuals,
          text: "groups",
        });
        numMutuals = 0;
        // Mutual interests
        if (user.interests) {
          user.interests.forEach((interest) => {
            if (numMutuals < 5 && this.user.interests.includes(interest)) {
              numMutuals += 1;
            }
          });
        }
        priority += this.getPriorityFor(numMutuals);
        mutualTracker.push({
          value: numMutuals,
          text: "interests",
        });
        numMutuals = 0;
        if (user.links) {
          user.links.forEach((link) => {
            if (this.user.links.includes(link)) {
              numMutuals += 1;
            }
          });
        }
        priority += numMutuals * 4;
        mutualTracker.push({
          value: numMutuals,
          text: "friends",
        });
        priority +=
          user.profileImage !==
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultUserImage%2FdefaultUserImage.jpeg?alt=media&token=d0140e78-d883-4a02-9827-82a89596eb6c"
            ? 10
            : 0;
        priority += user.images && user.images.length > 0 ? 2 : 0;
        priority += user.bio && user.bio.length > 0 ? 1 : 0;
        priority += user.year && user.year === this.user.year ? 5 : 0;
        mutualTracker.sort((a, b) => b.value - a.value);
        userDocArray[index].priority = priority;
        var releventInfo =
          mutualTracker[0].value !== 0
            ? mutualTracker[0].value + " mutual " + mutualTracker[0].text
            : "";
        var hasDash = mutualTracker[0].value !== 0 && user.year ? "- " : "";
        userDocArray[index].releventInfo = releventInfo;
        userDocArray[index].hasDash = hasDash;
      });
    },
    getPriorityFor(numMutuals) {
      switch (numMutuals) {
        case 1:
          return 1;
        case 2:
          return 2.5;
        case 3:
          return 5;
        case 4:
          return 8;
        case 5:
          return 15;
        default:
          return 0;
      }
    },
    goToCampus() {
      this.discoverWorld = false;
      this.exploreCampus = true;
      this.placeholderText = "Search your campus";
      this.resetGroups();
      this.fetchAllgroups();
    },
    goToWorld() {
      this.discoverWorld = true;
      this.exploreCampus = false;
      this.placeholderText = "Search all of Canada";
      this.resetGroups();
      this.fetchAllgroups();
    },
    resetGroups() {
      this.allGroups = [];
      this.featuredGroups = [];
      this.recommendedGroups = [];
      this.exploreGroups = [];
      this.selectedCategory = "";
    },
  },
};
</script>

<style src="@/styles/views/Discover.css"></style>
<style src="@/styles/views/AddCourse.css"></style>
